export default __webpack_public_path__ + "fr/static/media/Symbole-Visa.68589a59.svg";